module.exports = __webpack_public_path__ + "static/home_back2-9d888b50fe2f23f43267a06005d30463.png";